import { useEffect } from 'react';

export const SEOHead = ({ 
  title = "VersaillesPlus | Actualités Versailles",
  description = "VersaillesPlus - Votre source d'information locale sur Versailles et ses environs depuis 2007. Actualités, histoire, culture et vie locale.",
  image = "https://customer-assets.emergentagent.com/job_versailles-actu/artifacts/x061u1gg_logo%20Versailles%2B.jpeg",
  url = "",
  type = "website",
  publishedTime = "",
  author = "Jean-Baptiste Giraud"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Helper to set or create meta tag
    const setMeta = (property, content, isName = false) => {
      const attr = isName ? 'name' : 'property';
      let meta = document.querySelector(`meta[${attr}="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    // Basic meta
    setMeta('description', description, true);
    setMeta('author', author, true);
    
    // Open Graph
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:image', image);
    setMeta('og:url', url || window.location.href);
    setMeta('og:type', type);
    setMeta('og:site_name', 'VersaillesPlus');
    setMeta('og:locale', 'fr_FR');
    
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image', true);
    setMeta('twitter:title', title, true);
    setMeta('twitter:description', description, true);
    setMeta('twitter:image', image, true);
    
    // Article specific
    if (type === 'article' && publishedTime) {
      setMeta('article:published_time', publishedTime);
      setMeta('article:author', author);
    }
    
  }, [title, description, image, url, type, publishedTime, author]);
  
  return null;
};

export default SEOHead;
